module.exports = __webpack_public_path__ + "static/reinventing-fire-b6b07e5d5a1d331eb6d5b93659686a24.jpg";